import { render, staticRenderFns } from "./TableRandomGeneratorActivated.vue?vue&type=template&id=4799536a&scoped=true"
import script from "./TableRandomGeneratorActivated.vue?vue&type=script&lang=js"
export * from "./TableRandomGeneratorActivated.vue?vue&type=script&lang=js"
import style0 from "./TableRandomGeneratorActivated.vue?vue&type=style&index=0&id=4799536a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4799536a",
  null
  
)

export default component.exports